<template>
  <div class="aui-flexView">
    <router-view></router-view>
  </div>
</template>

<script>
// import Home from '@/pages/layer1/home'
// import Category from '@/pages/layer1/category'
// import Shelf from '@/pages/layer1/shelf'
// import User from '@/pages/layer1/user'
// import Bottom from '@/components/layer1/bottom'

export default {
  name: 'layer1',
  data () {
    return {
      transitionName: 'left'
    }
  },
  components: {
    // home: Home,
    // category: Category,
    // shelf: Shelf,
    // user: User,
    // bottom: Bottom
  }
}
</script>

<style scoped>
</style>
